/**
 * Venue API – venue management reads via Cloud Functions.
 * No direct Firestore access.
 */

import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase/config';

const functions = getFunctions(app, 'us-central1');

function call(name, data = {}) {
  const fn = httpsCallable(functions, name);
  return fn(data).then((res) => res.data);
}

/**
 * Fetch venue management data: venues, bookings, blocks, matches, tournaments, groups, managerEmails.
 */
export async function getVenueManagementData() {
  return call('venueGetManagementData', {});
}
